import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const ProductsAPI = {
  list: () => client.get("/products").then((r) => r.data),
  create: (data) => client.post("/products", data).then((r) => r.data),
  update: (id, data) => client.put(`/products/${id}`, data).then((r) => r.data),
  remove: (id) => client.delete(`/products/${id}`).then((r) => r.data),
};

export const MovementsAPI = {
  list: (params = {}) =>
    client.get("/movements", { params }).then((r) => r.data),
  create: (data) => client.post("/movements", data).then((r) => r.data),
  remove: (id) => client.delete(`/movements/${id}`).then((r) => r.data),
};

export const StatsAPI = {
  get: () => client.get("/stats").then((r) => r.data),
  lowStock: () => client.get("/low-stock").then((r) => r.data),
};
